import { StatusIndicator, STATUS_INDICATOR_VARIANTS } from 'cdk-radial';
import { FormattedMessage } from 'react-intl';

const StatusRenderer = ({ subStatus }: { subStatus: string }): JSX.Element => {
    const returnIndicator = (): JSX.Element => {
        switch (subStatus) {
            case 'Success':
                return (
                    <StatusIndicator
                        label={subStatus}
                        showIcon
                        variant={STATUS_INDICATOR_VARIANTS.POSITIVE as string}
                    />
                );
            case 'Failed':
                return (
                    <StatusIndicator
                        label={subStatus}
                        showIcon
                        variant={STATUS_INDICATOR_VARIANTS.NEGATIVE as string}
                    />
                );
            case 'In-Progress':
                return (
                    <StatusIndicator
                        label={subStatus}
                        showIcon
                        variant={STATUS_INDICATOR_VARIANTS.INFORMATION as string}
                    />
                );
            case 'Partial Success':
            default:
                return (
                    <StatusIndicator
                        label={subStatus}
                        showIcon
                        variant={STATUS_INDICATOR_VARIANTS.WARNING as string}
                    />
                );
        }
    };

    return <>{returnIndicator()}</>;
};

export default StatusRenderer;
